import FieldController from '../field.controller';
import { isDateObject } from '../../../util';

class NumericFieldController extends FieldController {

  get numericValue() {
    return this.value;
  }

  set numericValue(value) {
    this.value = this._parseNumeric(value);
  }

  _parseNumeric(value) {
    const definedAs = this.fieldType && this.fieldType.defined_as;

    switch (definedAs) {
      case 'FIELD_FLOAT1':
        return this._parseFloat(value, 1);
      case 'FIELD_FLOAT2':
        return this._parseFloat(value, 2);
      case 'FIELD_INTEGER':
        return this._parseInteger(value);
      default:
        return value;
    }
  }

  _parseInteger(value) {
    return parseInt(value);
  }

  _parseFloat(value, maxDecimals = 2) {
    const stringValue = value && value.toString && value.toString() || value;
    let parsedStringValue;
    if (typeof stringValue === 'string' || stringValue instanceof String) {
      const result = stringValue.match(/^((\d*)(\.\d*)?)/);
      if (result) {
        const numPart = result[2];
        console.debug(`numPart:`, numPart);
        if (result[3] && result[3].length) {
          // We have decimals
          const decimalPart = result[3].substring(0, maxDecimals + 1);
          parsedStringValue = numPart + decimalPart;
          console.debug(`decimalPart:`, decimalPart);
        } else {
          parsedStringValue = numPart;
        }
      } else {
        parsedStringValue = '';
      }
    } else {
      parsedStringValue = '';
    }
    console.debug(`_parseFloat(${value}, ${maxDecimals}) returning ${parsedStringValue}`);
    return parsedStringValue;
  }
}

export default NumericFieldController;
